import { HttpClient, HttpHeaders } from "@angular/common/http";
import { AfterViewInit, Component, Renderer2, ViewChild } from "@angular/core";
import { Router } from "@angular/router";
import { NullValidationHandler, OAuthErrorEvent, OAuthService } from "angular-oauth2-oidc";
import { LocalStorage, LocalStorageService, SessionStorageService } from "ngx-webstorage";
import { ScrollPanel } from "primeng/primeng";
import { environment } from "src/environments/environment";
import { authConfig, DiscoveryDocumentConfig } from "./app.config";
import { IdleTimeoutService } from "./idle-timeout.service.ts.service";

@Component({
    selector: "app-root",
    templateUrl: "./app.component.html",
    styleUrls: ["./app.component.scss"],
})
export class AppComponent implements AfterViewInit {
    layoutMode = "static";
    darkMenu = true;
    profileMode = "popup";
    rotateMenuButton: boolean;
    topbarMenuActive: boolean;
    overlayMenuActive: boolean;
    staticMenuDesktopInactive: boolean;
    staticMenuMobileActive: boolean;
    layoutMenuScroller: HTMLDivElement;
    menuClick: boolean;
    topbarItemClick: boolean;
    activeTopbarItem: any;
    resetMenu: boolean;
    menuHoverActive: boolean;
    grouped = true;

    @ViewChild("layoutMenuScroller", { static: true })
    layoutMenuScrollerViewChild: ScrollPanel;
    mscvpRole: any;
    UserDetails: any;
    envName: string;
    env: string;
    mscvpRoleId: any;
    globalColor :any;

    constructor(public renderer: Renderer2, public router: Router,public session: SessionStorageService,
               public localstorage: LocalStorageService,
               private http: HttpClient , private oauthService: OAuthService,
               private idleTimeoutService: IdleTimeoutService
    ) {
        // this.configure();
        this.envName 
        = environment.envName;
        const backendConfig = this.session.retrieve("backend_config");
        if (environment.dev == true) {
                //   let headers = new HttpHeaders();
                //           headers = headers.append(
                //               "authorization",
                //               this.localstorage.retrieve("token")
                //           );

        //     this.http.get(environment.apiUrl + "/getimage", { headers: headers ,  responseType: 'blob'}).subscribe((data:any) => { 
        //     const reader = new FileReader();
        //     reader.onloadend = () => {
        //       this.env =   reader.result as string;
        //       const favicon = document.getElementById('dynamic-favicon') as HTMLLinkElement;
        //       if (favicon) {
        //         favicon.href = reader.result as string; // Set the result (base64 image) as the href of the favicon
        //       }
        //     };
        //     reader.readAsDataURL(data);
        //    })
            document.getElementsByTagName("TITLE")[0].innerHTML="Rehlko-" + environment.envName;
        // } else if (environment.uat == true) {
        //     this.env = "../assets/logo/uat/topbar_sub_integrator.gif";
        //     document.getElementsByTagName("TITLE")[0].innerHTML="Rehlko SCVP-UAT"
        // } else if (environment.prod == true) {
        //     this.env = "../assets/logo/prod/topbar_sub_integrator.gif";
        //     document.getElementsByTagName("TITLE")[0].innerHTML="Rehlko SCVP-PROD"
        }
        if (backendConfig && backendConfig.globalColor) {
            this.globalColor = backendConfig.globalColor;
            this.env = backendConfig.globalImg
        } else {
            this.globalColor = "#a9d4e7";
            this.env =  'https://cdn.curtisinstruments.com/assets/logos/rehlko_logo.gif'
        }
        document.documentElement.style.setProperty('--globalColor', this.globalColor);
    }
    ngOnInit():void{
        this.idleTimeoutService.startWatching();
    }

    ngAfterViewInit() {
        //  setTimeout(() => {this.layoutMenuScrollerViewChild.moveBar(); }, 100);
    }

    onLayoutClick() {
        if (!this.topbarItemClick) {
            this.activeTopbarItem = null;
            this.topbarMenuActive = false;
        }
        if (!this.menuClick) {
            if (this.isHorizontal() || this.isSlim()) {
                this.resetMenu = true;
            }
            if (this.overlayMenuActive || this.staticMenuMobileActive) {
                this.hideOverlayMenu();
            }
            this.menuHoverActive = false;
        }
        this.topbarItemClick = false;
        this.menuClick = false;
    }

    onMenuButtonClick(event) {
        this.menuClick = true;
        this.rotateMenuButton = !this.rotateMenuButton;
        this.topbarMenuActive = false;
        if (this.layoutMode === "overlay" && !this.isMobile()) {
            this.overlayMenuActive = !this.overlayMenuActive;
        } else {
            if (this.isDesktop()) {
                this.staticMenuDesktopInactive =
                    !this.staticMenuDesktopInactive;
            } else {
                this.staticMenuMobileActive = !this.staticMenuMobileActive;
            }
        }
        event.preventDefault();
    }

    onMenuClick($event) {
        this.menuClick = true;
        this.resetMenu = false;
        if (!this.isHorizontal()) {
            //   setTimeout(() => {this.layoutMenuScrollerViewChild.moveBar(); }, 450);
        }
    }

    onTopbarMenuButtonClick(event) {
        this.topbarItemClick = true;
        this.topbarMenuActive = !this.topbarMenuActive;
        this.hideOverlayMenu();
        event.preventDefault();
    }

    onTopbarItemClick(event, item) {
        this.topbarItemClick = true;
        if (this.activeTopbarItem === item) {
            this.activeTopbarItem = null;
        } else {
            this.activeTopbarItem = item;
        }
        event.preventDefault();
    }

    onTopbarSubItemClick(event) {
        event.preventDefault();
    }

    hideOverlayMenu() {
        this.rotateMenuButton = false;
        this.overlayMenuActive = false;
        this.staticMenuMobileActive = false;
    }

    isTablet() {
        const width = window.innerWidth;
        return width <= 1024 && width > 640;
    }

    isDesktop() {
        return window.innerWidth > 1024;
    }

    isMobile() {
        return window.innerWidth <= 640;
    }

    isOverlay() {
        return this.layoutMode === "overlay";
    }

    isHorizontal() {
        return this.layoutMode === "horizontal";
    }

    isSlim() {
        return this.layoutMode === "slim";
    }

    isStatic() {
        return this.layoutMode === "static";
    }
    loginuserinfo() {
        this.UserDetails = this.session.retrieve("UserDetails");
           this.mscvpRoleId = this.UserDetails === null ? "" : this.UserDetails.roleId;
           this.mscvpRole = this.UserDetails.mscvpRole;
           if(this.mscvpRoleId ===2||this.mscvpRoleId ===3||this.mscvpRoleId ===6||this.mscvpRoleId ===7){
               this.router.navigate(["/mscvp/m-doc-repository"]);
           }
           else if(this.mscvpRoleId ===4||this.mscvpRoleId ===5){
               this.router.navigate(["/mscvp/sfgRepo"]);
           }
           else {
               this.router.navigate(["/mscvp/profile"]);
           } 
       }
       configure() {
        this.oauthService.configure(authConfig);
        this.oauthService.setStorage(localStorage);
        this.oauthService.tokenValidationHandler = new NullValidationHandler();
        this.oauthService.loadDiscoveryDocument(DiscoveryDocumentConfig.url);
        this.oauthService.events.subscribe(event => {
          if (event instanceof OAuthErrorEvent) {
            // console.log(event);
           
            // console.error(event);
          } else {
            // console.warn(event);
          }
        });
      }
}
